<template>
  <div id="dashboard">
    <Admin
      class="main"
      v-bind:class="{
        'tw-bg-light-gray': summaryAll != null && summaryAll.countsDocsAll > 0,
      }"
    >
      <v-main>
        <v-container
          fluid
          v-if="summaryAll != null && summaryAll.countsDocsAll > 0"
        >
          <v-row justify="center">
            <v-col md="12">
              <div class="wrapper">
                <div class="tw-text-xl tw-font-bold tw-mb-3">ยอดขาย</div>
                <div class="graph">
                  <chart></chart>
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col md="6">
              <div class="wrapper">
                <div class="tw-text-xl tw-font-bold tw-mb-3">ยอดภาษีขาย</div>
                <div class="summary">
                  <div
                    style="
                      background-color: #4abeef;
                      width: 60px;
                      height: 60px;
                      padding: 15px;
                      display: inline-block;
                      float: left;
                    "
                    class="rounded-circle"
                  >
                    <img src="/images/icons/icon_vat.svg" />
                  </div>
                  <div style="margin-left: 80px">
                    <span
                      >ยอดภาษีขายของเดือน
                      {{ getMonthFromYearMonth(selectedYearMonth) }}</span
                    >
                    <div class="price">
                      {{ formatMoney(summaryMonth.salesTaxAmount) }}
                    </div>
                  </div>
                </div>
              </div>
            </v-col>

            <v-col md="6">
              <div class="wrapper">
                <div class="tw-flex tw-justify-between tw-items-center tw-mb-3">
                  <div class="tw-text-xl tw-font-bold">ยอดเอกสาร</div>
                  <v-menu v-if="isSldAdmin" offset-y left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        outlined
                        color="#707070"
                        v-bind="attrs"
                        v-on="on"
                        :loading="isExporting"
                        class="export-btn"
                      >
                        <v-icon left small>mdi-download</v-icon>
                        Export
                      </v-btn>
                    </template>
                    <v-list dense>
                      <v-list-item @click="openYearlyExportDialog">
                        <v-list-item-icon>
                          <v-icon small>mdi-calendar-month</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>สรุปยอดรายเดือน (ทั้งปี)</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="exportMonthlySummary">
                        <v-list-item-icon>
                          <v-icon small>mdi-calendar-today</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>สรุปยอดรายวัน (เดือนที่เลือก)</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
                <div class="summary">
                  <div
                    style="
                      background-color: #f5bc1c;
                      width: 60px;
                      height: 60px;
                      padding: 15px;
                      display: inline-block;
                      float: left;
                    "
                    class="rounded-circle"
                  >
                    <img
                      src="/images/icons/sumdoc.svg"
                      width="100"
                      height="100"
                    />
                  </div>
                  <div style="margin-left: 80px">
                    <span
                      >ยอดเอกสารของเดือน
                      {{ getMonthFromYearMonth(selectedYearMonth) }}</span
                    >
                    <div class="docs">
                      {{ usageMonth.countsDocsAll?.toLocaleString() }} รายการ
                    </div>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>

          <!-- Year Selection Dialog -->
          <v-dialog v-model="yearSelectDialog" max-width="400">
            <v-card class="export-dialog">
              <v-card-title class="tw-text-lg tw-font-bold">เลือกปีที่ต้องการ Export</v-card-title>
              <v-card-text>
                <v-select
                  v-model="selectedExportYear"
                  :items="availableYears"
                  label="เลือกปี"
                  outlined
                  dense
                  color="#6ec39b"
                ></v-select>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="yearSelectDialog = false">ยกเลิก</v-btn>
                <v-btn color="#6ec39b" class="white--text export-dialog-btn" @click="exportYearlySummary">
                  <v-icon left>mdi-download</v-icon>
                  Export
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-container>
        <div
          v-if="
            selectedCompanyProductList?.isEtax &&
            summaryAll != null &&
            (!summaryAll.countsDocsAll || summaryAll.countsDocsAll === 0)
          "
        >
          <div
            class="tw-container tw-mx-auto fit-screen-div tw-overflow-hidden tw-flex tw-items-center tw-justify-center tw-text-center"
          >
            <div>
              <img src="/images/icons/db-connection.svg" class="mx-auto" />
              <p class="tw-w-full tw-pt-5">
                คุณยังไม่ได้เชื่อมต่อกับโปรแกรม <strong>e-Tax DB</strong>
              </p>
              <a href="">
                <button
                  class="tw-bg-light-blue tw-text-white tw-px-20 tw-py-4 tw-rounded-md"
                >
                  ดาวน์โหลด e-Tax DB
                </button>
              </a>
              <p
                class="tw-border-t tw-border-gray-500 tw-pt-5 tw-mt-5 tw-max-w-lg tw-mx-auto"
              >
                คุณยังไม่ได้เชื่อมต่อกับโปรแกรม e-Tax DB
                <a href="" class="tw-text-light-blue">ดาวน์โหลด</a>
              </p>
            </div>
          </div>
        </div>
      </v-main>
    </Admin>
  </div>
</template>

<script>
import Admin from "@/components/admin/admin-main-template";
import Chart from "@/components/admin/dashboard/chart";
import { mapState } from "vuex";
import { formatMoney } from "@/libs/currency";
import moment from "moment";
import logActivity from "@/libs/activityLogger";
import * as XLSX from "xlsx";
import fc from "@/firebaseConfig";
// import getRole from "@/libs/getRole";

// Removed hardcoded company IDs - now using isLab field from Firebase

export default {
  name: "Dashboard",
  components: {
    Admin,
    Chart,
  },
  data() {
    return {
      isExporting: false,
      yearSelectDialog: false,
      selectedExportYear: new Date().getFullYear(),
    };
  },
  computed: {
    ...mapState({
      // erpList: state => state.databasesByCompany.erpList,
      selectedSummaryDate: (state) =>
        state.summariesByCompany.selectedSummaryDate,
      selectedYearMonth: (state) => state.summariesByCompany.selectedYearMonth,
      summaryMonth: (state) => state.summariesByCompany.summaryMonth,
      usageMonth: (state) => state.summariesByCompany.usageMonth,
      summaryAll: (state) => state.summariesByCompany.summaryAll,
      isItemLoading: (state) => state.drawer.isItemLoading,
      selectedCompanyProductList: (state) =>
        state.companies.selectedCompanyProductList,
      selectedCompany: (state) => state.companies.selectedCompany,
      userCompany: (state) => state.user.userCompany,
    }),
    isSldAdmin() {
      // const isDeveloper = getRole(this.userCompany) === 'developer';
      const email = this.userCompany?.user?.email || '';
      const isSalaDaengEmail = email.endsWith('@sala-daeng.com');
      return isSalaDaengEmail;
    },
    availableYears() {
      const currentYear = new Date().getFullYear();
      const years = [];
      for (let i = 0; i < 5; i++) {
        const year = currentYear - i;
        years.push({ text: `${year} (พ.ศ. ${year + 543})`, value: year });
      }
      return years;
    },
  },
  created() {
    // Non-e-Tax companies have no dashboard content and are routed to their
    // product's default page by applyProductRedirect (the same map the watcher
    // uses). The route guard loads the product list before mount, so route now
    // from that state — the watcher only fires on *change*, which the dedup in
    // getCompanyProductList skips when the guard already populated it. If the
    // list isn't loaded yet, the watcher handles it once the fetch resolves.
    const pl = this.$store.state.companies.selectedCompanyProductList || {};
    if (Object.keys(pl).length && this.applyProductRedirect(pl)) return;
    this.query();
    this.getCompanyProductList();
  },
  methods: {
    // Route a company to its product's default page. Returns true when a
    // redirect was issued (e-Tax and unknown products stay on the dashboard).
    // Shared by created() and the selectedCompanyProductList watcher.
    applyProductRedirect(products) {
      if (!products) return false;
      if (products.isLab === true) {
        this.$router
          .replace({ name: "Company.AccountsPayableStudent", params: { companyId: this.$route.params.companyId } })
          .catch(() => {});
        return true;
      }
      return this.goToDefaultPage(products) !== "";
    },
    getCompanyProductList() {
      let companyId = this.$route.params.companyId;
      // The route guard (isCompanyAccessBlocked) already loads this company's
      // product list into the store on entry. Skip the duplicate network read
      // when it's present; fall back to fetching if the guard didn't populate
      // it (e.g. after a transient error), and clear the loading flag the guard
      // doesn't touch so the drawer menu doesn't stay in its loading state.
      const c = this.$store.state.companies;
      if (
        c.selectedCompany.companyId === companyId &&
        Object.keys(c.selectedCompanyProductList || {}).length
      ) {
        this.$store.commit("companies/setProductListLoading", false);
        return;
      }
      this.$store.dispatch("companies/getCompanyProductList", { companyId });
    },
    isValid(value) {
      return (
        value !== undefined && value !== null && value !== "" && value === true
      );
    },
    getMonthFromYearMonth: function (selectedYearMonth) {
      return moment(selectedYearMonth, "YYYY-MM").format("MMMM");
    },
    query: function () {
      let companyId = this.$route.params.companyId;
      if (companyId) {
        // this.$store.dispatch('databasesByCompany/getData', {id: companyId})
        this.$store.dispatch("summariesByCompany/getSummaryAll", { companyId });
      }
    },
    redirectToExchangeRate: function () {
      this.$router.push({ name: "Company.ExchangeRate" }).catch(() => {});
    },
    redirectToAiDoc: function () {
      this.$router.push({ name: "Company.reportDocumentAI" }).catch(() => {});
    },
    redirectToApAutomate: function () {
      this.$router.push({ name: "Company.AccountsPayable" }).catch(() => {});
    },
    redirectToApAutomateStudent: function () {
      this.$router.push({ name: "Company.AccountsPayableStudent" }).catch(() => {});
    },
    redirectToTKC: function () {
      this.$router.push({ name: "Company.DocumentTOPSERV" }).catch(() => {});
    },
    redirectToNsThaiSmartTax: function () {
      this.$router.push({ name: "Company.WithholdingTax" }).catch(() => {});
    },
    redirectToNsFixedAsset: function () {
      this.$router.push({ name: "Company.FixedAssetCount" }).catch(() => {});
    },
    goToDefaultPage(products) {
      if (products.isEtax) {
        return "";
      }
      if (products.isNsThaiSmartTax) {
        return this.redirectToNsThaiSmartTax()
      }
      if (products.isApAutomate) {
        return this.redirectToApAutomate()
      }
      if (products.isApAutomateStudent) {
        return this.redirectToApAutomateStudent()
      }
      if (products.isPdfDoc) {
        return this.redirectToAiDoc()
      }
      if (products.isExchangeRate) {
        return this.redirectToExchangeRate()
      }
      if (products.isTopserv) {
        return this.redirectToTKC()
      }
      if (products.isFixedAssetCount) {
        return this.redirectToNsFixedAsset()
      }
      return "";
    },
    openYearlyExportDialog() {
      this.selectedExportYear = new Date().getFullYear();
      this.yearSelectDialog = true;
    },
    // The company's own currency, defaulting to baht when it has no country set.
    formatMoney(scaledAmount) {
      return formatMoney(scaledAmount, (this.selectedCompany || {}).countryCode);
    },
    async exportYearlySummary() {
      this.yearSelectDialog = false;
      this.isExporting = true;
      try {
        const companyId = this.$route.params.companyId;
        const year = this.selectedExportYear;
        const summaries = [];

        // ดึงข้อมูลทั้ง 12 เดือนของปีที่เลือก จาก Summaries collection
        for (let month = 1; month <= 12; month++) {
          const monthStr = month.toString().padStart(2, "0");
          const yearMonth = `${year}-${monthStr}`;

          const summaryDoc = await fc.companies
            .doc(companyId)
            .collection("Summaries")
            .doc(yearMonth)
            .get();

          const data = summaryDoc.data();

          // รวม countsDocsType ทุกประเภท (1-7)
          let totalDocsCount = 0;
          if (data) {
            for (let i = 1; i <= 7; i++) {
              totalDocsCount += data[`countsDocsType${i}`] || 0;
            }
          }

          summaries.push({
            docsCount: totalDocsCount,
            month: moment(yearMonth, "YYYY-MM").format("MMMM"),
            yearAD: year,
            yearBE: year + 543,
          });
        }

        // คำนวณยอดรวม
        const totalDocs = summaries.reduce((sum, item) => sum + item.docsCount, 0);

        // แปลงข้อมูลเป็นรูปแบบที่ต้องการ
        const exportData = summaries.map((item) => ({
          "เดือน": item.month,
          "ปี ค.ศ.": item.yearAD,
          "ปี พ.ศ.": item.yearBE,
          "จำนวนเอกสาร": item.docsCount.toLocaleString(),
        }));

        // เพิ่มแถวรวม
        exportData.push({
          "เดือน": "รวมทั้งปี",
          "ปี ค.ศ.": "",
          "ปี พ.ศ.": "",
          "จำนวนเอกสาร": totalDocs.toLocaleString(),
        });

        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(exportData);

        // กำหนดความกว้างคอลัมน์
        worksheet["!cols"] = [
          { wch: 15 },
          { wch: 10 },
          { wch: 10 },
          { wch: 15 },
        ];

        XLSX.utils.book_append_sheet(workbook, worksheet, "สรุปรายเดือน");

        const fileName = `Yearly_Summary_Report_${year}.xlsx`;
        XLSX.writeFile(workbook, fileName);
      } catch (error) {
        console.error("Error exporting yearly summary:", error);
        alert("เกิดข้อผิดพลาดในการ Export กรุณาลองใหม่อีกครั้ง");
      } finally {
        this.isExporting = false;
      }
    },
    async exportMonthlySummary() {
      this.isExporting = true;
      try {
        const companyId = this.$route.params.companyId;
        const selectedMonth = this.selectedYearMonth;
        const daysInMonth = moment(selectedMonth, "YYYY-MM").daysInMonth();

        // ดึงข้อมูลรายวันจาก Summaries/Dates collection
        const datesSnapshot = await fc.companies
          .doc(companyId)
          .collection("Summaries")
          .doc(selectedMonth)
          .collection("Dates")
          .get();

        // สร้าง map ของข้อมูลรายวัน - รวม countsDocsType ทุกประเภท
        const dailyData = {};
        datesSnapshot.forEach((doc) => {
          const day = parseInt(doc.id);
          const data = doc.data();
          // รวม countsDocsType ทุกประเภท (1-7)
          let totalDocsCount = 0;
          for (let i = 1; i <= 7; i++) {
            totalDocsCount += data[`countsDocsType${i}`] || 0;
          }
          dailyData[day] = {
            docsCount: totalDocsCount,
          };
        });

        const dailySummaries = [];
        for (let day = 1; day <= daysInMonth; day++) {
          const dayStr = day.toString().padStart(2, "0");
          const fullDate = `${selectedMonth}-${dayStr}`;
          const data = dailyData[day] || { docsCount: 0 };

          dailySummaries.push({
            date: moment(fullDate, "YYYY-MM-DD").format("D MMMM YYYY"),
            dayName: moment(fullDate, "YYYY-MM-DD").format("dddd"),
            docsCount: data.docsCount,
          });
        }

        // คำนวณยอดรวม
        const totalDocs = dailySummaries.reduce((sum, item) => sum + item.docsCount, 0);

        // แปลงข้อมูลเป็นรูปแบบที่ต้องการ
        const exportData = dailySummaries.map((item) => ({
          "วันที่": item.date,
          "วัน": item.dayName,
          "จำนวนเอกสาร": item.docsCount.toLocaleString(),
        }));

        // เพิ่มแถวรวม
        exportData.push({
          "วันที่": "รวมทั้งเดือน",
          "วัน": "",
          "จำนวนเอกสาร": totalDocs.toLocaleString(),
        });

        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(exportData);

        // กำหนดความกว้างคอลัมน์
        worksheet["!cols"] = [
          { wch: 20 },
          { wch: 12 },
          { wch: 15 },
        ];

        XLSX.utils.book_append_sheet(workbook, worksheet, "สรุปรายวัน");

        const fileName = `Monthly_Summary_Report_${selectedMonth}.xlsx`;
        XLSX.writeFile(workbook, fileName);
      } catch (error) {
        console.error("Error exporting monthly summary:", error);
        alert("เกิดข้อผิดพลาดในการ Export กรุณาลองใหม่อีกครั้ง");
      } finally {
        this.isExporting = false;
      }
    },
  },
  beforeDestroy() {
    // this.$store.dispatch('databasesByCompany/getDataListUnsubscribe')
    this.$store.dispatch("summariesByCompany/getSummaryMonthUnsubscribe");
    this.$store.dispatch("summariesByCompany/getUsageMonthUnsubscribe");
    this.$store.dispatch("summariesByCompany/getSummaryAllUnsubscribe");
    this.$store.dispatch("summariesByCompany/getSummaryDayFirstUnsubscribe");
    this.$store.dispatch("summariesByCompany/getSummaryDaySecondUnsubscribe");
  },
  watch: {
    selectedCompanyProductList(newValue) {
      this.applyProductRedirect(newValue);
    },
  },
  mounted() {
    logActivity("page_view", { page_title: "Dashboard" });
  },
};
</script>

<style lang="scss">
#dashboard {
  .wrapper {
    margin: 0 20px 0;
    padding: 0 10px 0;

    .graph {
      background: #ffffff;
      border-radius: 20px;
      overflow: hidden;
      box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    }

    .summary {
      width: 100%;
      max-width: 475px;
      background: #ffffff;
      border-radius: 20px;
      overflow: hidden;
      box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
      padding: 20px;
      align-items: center;

      .price {
        color: #4abeef;
        font-size: 24px;
        font-weight: bold;
      }
      .docs {
        color: #f5bc1c;
        font-size: 24px;
        font-weight: bold;
      }
    }
  }

  .export-btn {
    text-transform: none;
    font-size: 14px;
    border-radius: 8px;
    letter-spacing: 0;
  }

  .export-dialog {
    border-radius: 12px !important;
    overflow: hidden;

    .v-card__title {
      border-top: none;
    }
  }

  .export-dialog-btn {
    text-transform: none;
    letter-spacing: 0;
    border-radius: 8px;
  }
}
.fit-screen-div {
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  position: absolute;
}
</style>
